<h1 mat-dialog-title>{{data.titulo}}</h1>

<mat-dialog-content>
  <p class="info-text">{{data.mensagem}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onOkClick()" mat-dialog-close>Fechar</button>
</mat-dialog-actions>
